import { ShowIf } from '@ztechapps/webui.util'
import React from 'react'
import { useError } from '@ztechapps/common.hook'
import type { Task } from '@ztechapps/common.contract'
import { useTaskListContext } from '../Context'
import { TaskInput } from '../../TaskInput'
import { useAddTaskSubTasks } from '@ztechapps/task.common'

export const EmptySubTaskList = () => {
  const [_onAdd, { loading, error }] = useAddTaskSubTasks()
  const { disabled, subTaskConfig } = useTaskListContext()
  const taskId = subTaskConfig?.taskId
  useError(error)

  const onAdd = async (taskName: string): Promise<void> => {
    await _onAdd({
      taskId,
      subTasks: [{ name: taskName } as Task],
    })
  }

  return (
    <ShowIf condition={!disabled}>
      <TaskInput onAdd={onAdd} disabled={loading} />
    </ShowIf>
  )
}
